import {
  AnalyzeCsvRequest,
  AnalyzeCsvResponse,
  CreateLead,
  ImportLeadContext,
  ImportLeadItem,
  ImportRequest,
  ImportResponse,
  ReadLead,
  UpdateLead,
} from '@tinct/core-api-models';
import { ApiClient } from '../api-client/api-client';
import {
  ApiCollectionResponse,
  GetCollectionQueryParams,
  GetQueryByIdParams,
} from '../types';

export interface GetLeadsFilter {
  ownerId?: string;
  companyId?: string;
}

export class LeadsEndpoint {
  constructor(private client: ApiClient) {}

  async getLead(params: GetQueryByIdParams<ReadLead>): Promise<ReadLead> {
    return this.client.getById<ReadLead>(
      `/api/v1/leads/${params.id}`,
      params.fields,
    );
  }

  async getLeads(
    params: GetCollectionQueryParams<ReadLead, GetLeadsFilter>,
  ): Promise<ApiCollectionResponse<ReadLead>> {
    const { fields, offset, limit, filters, staticParams } = params;
    return this.client.getCollection<ReadLead>('/api/v1/leads', fields, {
      offset,
      limit,
      ...filters,
      ...staticParams,
    });
  }

  async createLead(data: CreateLead): Promise<ReadLead> {
    return this.client.post<ReadLead>('/api/v1/leads', data);
  }

  async updateLead(id: string, data: UpdateLead): Promise<ReadLead> {
    return this.client.put<ReadLead>(`/api/v1/leads/${id}`, data);
  }

  async patchLead(id: string, data: Partial<UpdateLead>): Promise<ReadLead> {
    return this.client.patch<ReadLead>(`/api/v1/leads/${id}`, data);
  }

  async analyzeCsv(
    data: AnalyzeCsvRequest<ImportLeadContext>
  ): Promise<AnalyzeCsvResponse> {
    return this.client.post<AnalyzeCsvResponse>('/api/v1/leads/_analyze-csv', data);
  }

  async importLeads(
    data: ImportRequest<ImportLeadItem, ImportLeadContext>
  ): Promise<ImportResponse> {
    return this.client.post<ImportResponse>('/api/v1/leads/_import', data);
  }
}
